document.addEventListener('DOMContentLoaded', () => {
  centerSecondCategory();

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    const addButton = event.submitter;
    if (!form || !addButton?.classList.contains('j-product__add')) return;

    event.preventDefault();
    const originalText = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'Adicionando...';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const item = await response.json();
      if (!response.ok) throw new Error(item.description || 'Não foi possível adicionar o produto.');

      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((result) => result.json());
      document.querySelectorAll('[data-cart-count]').forEach((count) => {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      });
      showCartConfirmation(item, `${root}cart`);
    } catch (error) {
      showCartConfirmation(null, null, error.message);
    } finally {
      addButton.disabled = false;
      addButton.textContent = originalText;
    }
  });
});

function centerSecondCategory() {
  if (!window.matchMedia('(max-width: 600px)').matches) return;
  const carousel = document.querySelector('.jouir-categories');
  const secondCard = carousel?.querySelectorAll('.jouir-category')[1];
  if (!carousel || !secondCard) return;
  requestAnimationFrame(() => {
    carousel.scrollLeft = secondCard.offsetLeft - (carousel.clientWidth - secondCard.clientWidth) / 2;
  });
}

function showCartConfirmation(item, cartUrl, errorMessage) {
  document.querySelector('.jouir-cart-toast')?.remove();
  const toast = document.createElement('aside');
  toast.className = `jouir-cart-toast${errorMessage ? ' jouir-cart-toast--error' : ''}`;
  toast.setAttribute('role', 'status');
  toast.innerHTML = errorMessage
    ? `<button class="jouir-cart-toast__close" aria-label="Fechar">×</button><strong>Não foi possível adicionar</strong><p>${escapeHtml(errorMessage)}</p>`
    : `<button class="jouir-cart-toast__close" aria-label="Fechar">×</button><small>Adicionado ao carrinho</small><strong>${escapeHtml(item.product_title)}</strong><div><button class="jouir-cart-toast__continue" type="button">Continuar comprando</button><a href="${cartUrl}">Ver carrinho</a></div>`;
  document.body.appendChild(toast);
  requestAnimationFrame(() => toast.classList.add('is-visible'));
  toast.querySelector('.jouir-cart-toast__close')?.addEventListener('click', () => closeToast(toast));
  toast.querySelector('.jouir-cart-toast__continue')?.addEventListener('click', () => closeToast(toast));
  window.setTimeout(() => closeToast(toast), 7000);
}

function closeToast(toast) {
  toast.classList.remove('is-visible');
  window.setTimeout(() => toast.remove(), 250);
}

function escapeHtml(value) {
  const element = document.createElement('div');
  element.textContent = value || '';
  return element.innerHTML;
}
